import { request } from 'app/utils';
import { AxiosResponse } from 'axios';
import { Box, Loading } from 'components';
import { ModulesApiResponse, useModules } from 'features/modules';
import { useSchool } from 'features/school';
import React, { useCallback, useState } from 'react';
import Tab from '@material/react-tab';
import TabBar from '@material/react-tab-bar';
import styled from 'styled-components';

import './styles.scss';

const TabsWrapper = styled(Box)`
  .mdc-tab-bar {
    .mdc-tab {
      .mdc-tab__text-label {
        color: ${({ theme }) => theme.colors.gray_400};
        opacity: 1;
      }

      &.mdc-tab--active {
        .mdc-tab__text-label {
          color: ${({ theme }) => theme.colors.primary_400};
        }
      }

      .mdc-tab-indicator {
        > .mdc-tab-indicator__content--underline {
          background-color: ${({ theme }) => theme.colors.primary_400};
        }
      }
    }
  }
`;

interface ModulesGroupsProps {
  productSlug: string;
}

const ModulesGroups = ({ productSlug }: ModulesGroupsProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [loadingEdit, setLoadingEdit] = useState(false);

  const { groups, modulesInfo, setModules } = useModules();

  const { apiGatewayUrl } = useSchool();

  const handleActiveIndexUpdate = useCallback(
    async (index: number) => {
      if (activeIndex !== index) {
        setActiveIndex(index);
        setLoadingEdit(true);

        await request({
          url: `/api/v1/School/ProductContentTimeline/${productSlug}?productClassUuid=${modulesInfo.productClassUuid}&productClassTimelineGroupUuid=${groups[index].uuid}`,
          method: 'get',
          baseURL: apiGatewayUrl,
        })
          .then((response: AxiosResponse<ModulesApiResponse>) => {
            setModules(response.data);
          })
          .finally(() => {
            setLoadingEdit(false);
          });
      }
    },
    [groups]
  );

  return !!groups.length ? (
    <TabsWrapper maxWidth="100%" mt={{ m: 30, d: 40 }}>
      {loadingEdit && <Loading alpha />}

      <TabBar activeIndex={activeIndex} handleActiveIndexUpdate={handleActiveIndexUpdate}>
        {groups.map((group, groupIndex) => {
          return (
            <Tab key={`tab-group-${groupIndex.toString()}`} focusOnActivate={false}>
              <span className="mdc-tab__text-label">{group.description}</span>
            </Tab>
          );
        })}
      </TabBar>
    </TabsWrapper>
  ) : (
    <></>
  );
};

export default ModulesGroups;

// <div className="mdc-tab-bar" role="tablist">
//   <div className="mdc-tab-scroller">
//     <div className="mdc-tab-scroller__scroll-area">
//       <div className="mdc-tab-scroller__scroll-content">
//         {groups.map((group) => {
//           const activeGroup = modulesInfo?.currentTimelineGroupUuid === group.uuid;

//           return (
//             <button
//               className={clsx(['mdc-tab'], {
//                 'mdc-tab--active': activeGroup,
//               })}
//               role="tab"
//               aria-selected="false"
//               tabIndex={-1}
//               id="mdc-tab-1"
//               onClick={() => fetchGroup(group.uuid)}
//             >
//               <span className="mdc-tab__content">
//                 <span className="mdc-tab__text-label">{group.description}</span>
//               </span>
//               <span
//                 className={clsx(['mdc-tab-indicator'], {
//                   'mdc-tab-indicator--active': activeGroup,
//                 })}
//               >
//                 <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
//               </span>
//               <span className="mdc-tab__ripple"></span>
//             </button>
//           );
//         })}
//         {/*
//         <button
//           className="mdc-tab"
//           role="tab"
//           aria-selected="false"
//           tabIndex={-1}
//           id="mdc-tab-2"
//         >
//           <span className="mdc-tab__content">
//             <span className="mdc-tab__text-label">Merchandise</span>
//           </span>
//           <span className="mdc-tab-indicator">
//             <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
//           </span>
//           <span className="mdc-tab__ripple mdc-ripple-upgraded"></span>
//         </button>
//         <button
//           className="mdc-tab mdc-tab--active"
//           role="tab"
//           aria-selected="true"
//           tabIndex={0}
//           id="mdc-tab-3"
//         >
//           <span className="mdc-tab__content">
//             <span className="mdc-tab__text-label">About Us</span>
//           </span>
//           <span className="mdc-tab-indicator mdc-tab-indicator--active">
//             <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
//           </span>
//           <span className="mdc-tab__ripple mdc-ripple-upgraded"></span>
//         </button> */}
//       </div>
//     </div>
//   </div>
// </div>
